import React, { Component, PropTypes } from 'react';

import css from './confirm.scss';

import InputSubmit from  './input/submit';
import InputText from  './input/text';

export default class PromptDialog extends Component {
	static propTypes = {
		text: PropTypes.string,
	};

	static defaultProps = {
		text: 'Enter value:',
	};

	constructor(props) {
		super();

		this.promiseResolve = function() {};
		this.promiseReject = function() {};

		this.newPromise();
		this._handleEscKey = this._handleEscKey.bind(this);

		this.state = {
			show: false,
			text: 'Are you sure?',
			placeholder: '',
			validate: [],
			value: '',
		};
	}

	render() {
		let className = 'confirm-dialog';

		if (this.state.show) {
			className += ' confirm-dialog--show';
		}

		return (
			<div className={className} onClick={this.handleCancel.bind(this)}>
				<div className='confirm-dialog__dialog' onClick={(e) => e.stopPropagation()}>
					<div className='confirm-dialog__dialog__content'>
						<div>{this.state.text}</div>
						<br/>
						<br/>
						<InputText tabIndex={this.state.show ? 0 : -1} type='text' name='text' ref='input' placeholder={this.state.placeholder} validate={this.state.validate} onInput={this.onTextInput.bind(this)} value={this.state.value}  />
					</div>

					<div className='confirm-dialog__dialog__actions'>
						<button tabIndex={this.state.show ? 0 : -1} onClick={this.handleOK.bind(this)} ref='confirm'>Confirm</button>
						<button tabIndex={this.state.show ? 0 : -1} onClick={this.handleCancel.bind(this)} className='button--dark'>Cancel</button>
					</div>
				</div>
			</div>
		);
	}

	onTextInput(e) {
		this.setState({
			...this.state,
			value: e.target.value,
		});
	}

	handleOK(e) {
		e.preventDefault();

		if (this.refs.input.testValidity()) {
			this.promiseResolve(this.state.value);
			this.setState({
				...this.state,
				show: false,
				value: '',
			});
		} else {
			console.log('invalid');
		}
	}

	handleCancel(e) {
		e.preventDefault();
		this.promiseReject();
		this.setState({
			...this.state,
			show: false,
			value: '',
		});
	}

	newPromise() {
		this.promise = new Promise((resolve, reject) => {
			this.promiseResolve = resolve;
			this.promiseReject = reject;
		});
	}

	prompt(text, placeholder = '', validate = [], value = '') {
		this.newPromise();
		this.setState({
			...this.state,
			show: true,
			text: text,
			value: value,
			placeholder: placeholder,
			validate: validate,
		});
		this.refs.confirm && this.refs.confirm.focus();

		document.addEventListener('keydown', this._handleEscKey, false);

		this.promise.then(() => {
			document.removeEventListener('keydown', this._handleEscKey, false);
		}).catch(() => {
			document.removeEventListener('keydown', this._handleEscKey, false);
		});

		return this.promise;
	}

	_handleEscKey(e) {
		if (e.keyCode === 27) {
			this.handleCancel(e);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/prompt.js
 **/